import './ReferralOwnershipBanner.scss';
import React from 'react';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import PersonIcon from '@mui/icons-material/Person';

interface ReferralOwnershipBannerProps {
  isOwner: boolean;
  ownerName: string;
}

export const ReferralOwnershipBanner: React.FC<ReferralOwnershipBannerProps> = ({
  isOwner,
  ownerName,
}) => {
  if (!ownerName) return null;

  if (isOwner) {
    return (
      <div className="referral-ownership-banner">
        <ThumbUpIcon className="banner-icon" />
        <span className="banner-text">You've claimed ownership over this case</span>
      </div>
    );
  }

  return (
    <div className="referral-ownership-banner referral-ownership-banner--other">
      <PersonIcon className="banner-icon" />
      <span className="banner-text">{ownerName} has ownership over this case</span>
    </div>
  );
};
